<template>
  <div class="categories-list pos-relative">
    <div class="active-category padding-b-20" v-if="activeCategory">
      <Button icon="md-arrow-back" long @click="handleBack">Back</Button>
      <div class="padding-20 text-center">
        <Avatar :icon="(activeCategory.icon)? activeCategory.icon:'logo-buffer'" :size="40" style="margin-bottom:10px;"/>
        <h3 style="color:#000000">{{ activeCategory.name }}</h3>
      </div>
      <p v-if="categories.length">
        <Icon type="ios-bookmark-outline" />
        <span>Browse sub-categories</span>
      </p>
    </div>
    <Card v-for="(cat, idx) in categories" :key="idx" style="margin-bottom:20px;" class="category-card clickable" @click.native="handleFilterByCategory(cat)">
      <div>
        <Icon :type="(cat.icon)? cat.icon:'logo-buffer'" :size="30" style="margin-bottom:20px;"/>
        <p>{{ cat.name }}</p>
        <small>{{ cat.listing_count }} listings</small>
      </div>
    </Card>
    <Spin fix v-if="isLoading"></Spin>
  </div>
</template>

<script>
import { fetchCategories, fetchCategory, fetchFirstCategoryBySlug, fetchSecondCategoryBySlug } from '@/services/categories'

export default {
  data () {
    return {
      isLoading: false,
      categories: [],
      activeCategory: null
    }
  },

  watch: {
    $route: {
      handler (val) {
        if (this.$route.params.secondcat) {
          this.getSecondCategory()
        } else if (this.$route.params.firstcat) {
          this.getFirstCategory()
        } else if (this.$route.params.cat) {
          this.getCategory()
        } else {
          if (this.$route.query && this.$route.query.tab && this.$route.query.tab === 'categories') {
            this.getCategories()
          }
        }
      },
      deep: true
    }
  },

  mounted () {
    if (this.$route.params.secondcat) {
      this.getSecondCategory()
    } else if (this.$route.params.firstcat) {
      this.getFirstCategory()
    } else if (this.$route.params.cat) {
      this.getCategory()
    } else {
      if (this.$route.query && this.$route.query.tab && this.$route.query.tab === 'categories') {
        this.getCategories()
      }
    }
  },

  methods: {
    getCategories () {
      this.isLoading = true
      this.categories = []
      this.activeCategory = null
      fetchCategories().then(res => {
        if (this.$route.params && this.$route.params.cat) {
          this.activeCategory = res.data.results.find(item => item.slug === this.$route.params.cat)
          this.categories = this.activeCategory.subcategories
          this.$emit('reload', this.activeCategory.id)
        } else {
          this.categories = res.data.results
          this.$emit('reload')
        }
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to fetch categories: ', err)
        this.isLoading = false
      })
    },

    getCategory () {
      this.isLoading = true
      this.categories = []
      this.activeCategory = null
      fetchCategory(this.$route.params.cat).then(res => {
        this.activeCategory = res.data
        this.categories = res.data.subcategories
        this.$emit('reload', res.data.id)
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to get category by slug: ', err)
        this.isLoading = false
      })
    },

    getFirstCategory () {
      this.isLoading = true
      this.categories = []
      this.activeCategory = null
      fetchFirstCategoryBySlug(this.$route.params.cat, this.$route.params.firstcat).then(res => {
        this.activeCategory = res.data
        this.categories = res.data.subcategories
        this.$emit('reload', res.data.id)
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to get first category by slug: ', err)
        this.isLoading = false
      })
    },

    getSecondCategory () {
      this.isLoading = true
      this.categories = []
      this.activeCategory = null
      fetchSecondCategoryBySlug(this.$route.params.cat, this.$route.params.firstcat, this.$route.params.secondcat).then(res => {
        this.activeCategory = res.data
        this.categories = res.data.subcategories
        this.$emit('reload', res.data.id)
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to get second category by slug: ', err)
        this.isLoading = false
      })
    },

    handleFilterByCategory (data) {
      if (this.$route.name === 'company-category') {
        this.$router.push({
          name: 'company-category-first',
          params: {
            cat: this.$route.params.cat,
            firstcat: data.slug
          },
          query: {}
        })
      } else if (this.$route.name === 'company-category-first') {
        this.$router.push({
          name: 'company-category-second',
          params: {
            cat: this.$route.params.cat,
            firstcat: this.$route.params.firstcat,
            secondcat: data.slug
          },
          query: {}
        })
      } else {
        this.$router.push({
          name: 'company-category',
          params: {
            cat: data.slug
          },
          query: {}
        })
      }
    },

    handleBack () {
      if (this.$route.name === 'company-category-second') {
        this.$router.push({
          name: 'company-category-first',
          params: {
            cat: this.$route.params.cat,
            firstcat: this.$route.params.firstcat
          },
          query: {}
        })
      } else if (this.$route.name === 'company-category-first') {
        this.$router.push({
          name: 'company-category',
          params: {
            cat: this.$route.params.cat
          },
          query: {}
        })
      } else {
        this.$router.push({
          name: 'company-categories',
          query: {
            tab: 'categories'
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.categories-list {
  .category-card {
    background: $secondary;
    color: #ffffff;
    &:hover {
      background: $secondaryDarker;
    }
  }
}
</style>
